import React, { Component } from "react";
import style from "./list.module.sass";
import { Table, Icon, Spin } from "antd";
import { Button, Modal } from "../../../../helpers/commonUi";
import Service from "./Service";
import { Http } from "../../../../helpers/axois";
import moment from 'moment'
import { ReactComponent as TableEdit } from '../../../../assets/svg/editIcon.svg'
import { ReactComponent as Delete } from '../../../../assets/svg/delete.svg'
import serviceImg from "../../../../assets/images/create_service.svg";

import NoData from "../../NoData";
import { AppState } from "../../../../stateManager/store";
import { connect } from "react-redux";
import { pushToast } from "../../../../stateManager/store/toast/actions";
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'
import { selectedServices } from "../../../../stateManager/store/solo/action";
import { ReactComponent as Acl } from '../../../../assets/svg/acl.svg'
import AclServiceDrawer from "../../Assisted/forms/create/AclServiceDrawer";
import SearchBar, { highlightMatch } from "../../../../helpers/SearchBar";
// import VulnerabilitiesDrawer from "../../common/vulnerabilityModel";
// import vulnerabilitiesImg from "../../../../assets/images/vulnerabilities.svg"
// import secure from '../../../../assets/images/secure.svg'


interface State {
  visible: boolean;
  editInitialData?: {};
  editSoloIntitialData?: {};
  serviceList?: any[];
  soloServiceList?: any[];
  editable: boolean;
  editvisible?: boolean;
  loading?: boolean;
  deleteVisible: boolean;
  deleteData: any;
  editType: any;
  aclDrawerVisible?:boolean;
  filteredData: any[];
  searchValue: string;
  searchRef: React.RefObject<{ clearSearch: () => void }>
  // showVulnerabilityModal: boolean,
  // vulnerabilityReport: {line: number, ruleId: string, message: string}[];
}

interface Props {
  match?: any;
  app?: any;
  history?: any;
  deleteService: (data: any) => void;
  appVersion?: { currentVersion: boolean, versionId: string }
  pushToast: (data: any) => void;
  selectedServices: (data: any) => void;
  orgPermissions: any;
  appPermissions: any;
  currentBranch?: any;
}

class ServiceList extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      editInitialData: {},
      editSoloIntitialData: {},
      editType: "",
      editable: false,
      serviceList: [],
      soloServiceList: [],
      editvisible: false,
      loading: false,
      deleteVisible: false,
      deleteData: {},
      aclDrawerVisible: false,
      filteredData: [],
      searchValue: "",
      searchRef: React.createRef(),
      // vulnerabilityReport: [],
      // showVulnerabilityModal: false
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    this.versionUpdate(this.props);
  }

  componentWillReceiveProps(props: Props) {
    if (props.appVersion !== this.props.appVersion) {
      this.versionUpdate(props);
    }
  }

  versionUpdate(props: Props) {
    const version = props.appVersion;
    if (version) {
      this.getSoloService(props);
    }
  }


  getSoloService(props: Props) {
    const version = props.appVersion && props.appVersion.versionId;
    const appId = this.props.match.params.appId;
    Http.get(`/apps/${appId}/solo-services?versionId=${version}`).subscribe((soloServiceRes: any) => {
      const responseData = soloServiceRes && soloServiceRes.services
      this.setState({
        soloServiceList: responseData,
        filteredData: responseData,
        loading: false,
      });
    }, (err) => {
      if (err !== 'Forbidden') {
        this.setState({
          soloServiceList: [],
          filteredData: [],
          loading: false
        })
        this.props.pushToast(
          { type: 'error', message: (err && err.message) ? err.message : "Services Getting failed" }
        )
      }
    });
  }


  deleteSoloService(soloServiceid: any) {
    this.setState({
      loading: true
    })
    const appId = this.props.match.params.appId
    const versionId = this.props.appVersion && this.props.appVersion.versionId;
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
    Http.delete(`/apps/${appId}/solo-services/${soloServiceid}?versionId=${versionId}&branchId=${currentBranchId}`).subscribe((res) => {
      this.props.pushToast(
        { type: 'success', message: 'Solo service deleted successfully' }
      )
      this.getSoloService(this.props);
      this.setState({
        loading: false, deleteVisible: false,
        searchValue: "",
        filteredData: this?.state?.serviceList || []
      })
    }, (err) => {
      this.setState({
        loading: false,
        deleteVisible: false,
        searchValue: "",
        filteredData: this?.state?.serviceList || []
      })
      this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : 'Solo service deletion failed' }
      )
    })
  }

  getSoloInitialData = async (serviceId: string) => {
    try {
        const versionId = this.props.appVersion && this.props.appVersion.versionId;
        const appId = this.props?.match?.params?.appId;
        const response = await Http.get(`/apps/${appId}/solo-services/${serviceId}?versionId=${versionId}`).toPromise();
        this.setState({ editSoloIntitialData: response });
        return response;
    } catch (error) {
        console.error("Error occurred:", error);
        return null;
    }
  }



  render() {
    //const isRenderSolo = window.location.origin.includes("localhost") || window.location.origin.includes("testing");
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.match.params.appId] && this.props.currentBranch[this.props.match.params.appId].branchId
    const currentVersion = this.props.appVersion && this.props.appVersion.currentVersion
    const canEditService = currentVersion && (this.props.orgPermissions.includes('service.Edit') || this.props.appPermissions.includes('service.Edit'))
    const canCreateService = currentVersion && (this.props.orgPermissions.includes('service.Create') || this.props.appPermissions.includes('service.Create'))
    const canDeleteService = currentVersion && (this.props.orgPermissions.includes('service.Delete') || this.props.appPermissions.includes('service.Delete'))
    const canViewService = this.props.orgPermissions.includes('service.View') || this.props.appPermissions.includes('service.View')

    // if (currentVersion) {
      const soloColumns: any = [
        // {
        //   title: "Display Name",
        //   dataIndex: "displayName",
        //   key: "displayName",
        // },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          render: (value: string)=>{
            const formattedValue = highlightMatch(value, this.state.searchValue)
            return formattedValue
          }
        },
        {
          title: "Created By",
          dataIndex: "createdBy",
          key: "createdBy",
          render: (value: string)=>{
            const formattedValue = highlightMatch(value, this.state.searchValue)
            return formattedValue
          }
        },
        {
          title: "Created At",
          dataIndex: "createdAt",
          key: "createdAt",
            render: (text: string) => {
              let formattedValue: any  = text ?  moment(text).local().format("DD-MM-YYYY hh:mm a") : "-"
              formattedValue = highlightMatch(formattedValue, this.state.searchValue)
              return formattedValue
            }
        },
        {
          title: "Updated At",
          dataIndex: "updatedAt",
          key: "Updated At",
          render: (text: string) => {
            let formattedValue: any  = text ?  moment(text).local().format("DD-MM-YYYY hh:mm a") : "-"
            formattedValue = highlightMatch(formattedValue, this.state.searchValue)
            return formattedValue
          }
        },
        // {
        //   title: '',
        //   dataIndex: '',
        //   key: 'button',
        //   render: (text: any, record: any) => {
        //     if (!record?.vulnerabilityScan) {
        //       return null
        //     }
        //     return (
        //       <>
        //         {record?.vulnerabilityScan?.status === "FAILED" ? <div className={style.vulnerability} onClick={(e) => {
        //           e.stopPropagation();
        //           this.setState({ vulnerabilityReport: record?.vulnerabilityScan?.report?.issues })
        //           this.setState({ showVulnerabilityModal: true })
        //         }}>
        //           {/* <img src={vulnerabilitiesImg} alt="vulnerabilities" /> */}
        //           {/* <Vulnerabilities style={{height: 20, width: 20}}/> */}
        //           <img src={vulnerabilitiesImg} alt="vulnerabilities" style={{ height: 20, width: 20 }} />
        //           <span className={style.vulnerabilitiesText}>{`vulnerabilities (${record?.vulnerabilityScan?.report?.issues?.length})`}</span>
        //         </div>

        //           : <div className={style.secure}>
        //             {/* <img src={vulnerabilitiesImg} alt="vulnerabilities" /> */}
        //             {/* <Secure /> */}
        //             <img src={secure} alt="secure" style={{ height: 20, width: 20 }} />
        //             <span className={style.secureText}>Secure</span>
        //           </div>}
        //       </>
        //     )
        //   },
        // }
      ];

      if (currentVersion) {
        soloColumns.push(
          {
            title: "Action",
            key: "action",
            render: (text: any, record: any) => (
              <div className="action action_grp">
                <span data-test-id="action_edit"
                  className="action-icon acl-icon"
                  title="Policy"
                  style={{ margin: 0 }}
                  onClick={e => {
                    e.stopPropagation();
                    if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                      this.props.pushToast({
                        type: 'error',
                        message: 'Cannot modify a previous app version'
                      })
                      return
                    }
                    this.setState({ aclDrawerVisible: true, editInitialData: record, })
                  }}
                >
                  <Acl style={{ width: "15px", height: "15px" }} />
                </span>
                <span
                  data-test-id="action_edit"
                  title="Edit"
                  className="action-icon edit-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.getSoloInitialData(record.id)
                        .then((response) => {
                            if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                                this.props.pushToast({
                                    type: 'error',
                                    message: 'Cannot modify a previous app version'
                                })
                                return
                            }
              
                            if (canEditService && response !== null) {
                                this.setState({
                                    editvisible: true,
                                    editType: "solo",
                                    editSoloIntitialData: response,
                                    editable: true,
                                });
                            } else {
                                this.props.pushToast({
                                    type: 'error',
                                    message: 'You are not authorized to edit this service'
                                });
                            }
                        })
                        .catch(error => {
                            console.error("Error:", error);
                            // Handle error if the promise is rejected
                            // You might want to notify the user about the error
                        });
                }}                
                >
                  <TableEdit height='15px' width='15px' />
                </span>
                {this.state.soloServiceList!.length >= 1 && (
                  <span
                    data-test-id="action_delete"
                    className="action-icon delete-icon"
                    title="Delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                        this.props.pushToast({
                          type: 'error',
                          message: 'Cannot modify a previous app version'
                        })
                        return
                      }
                      if (canDeleteService) {
                        this.setState({
                          deleteVisible: true,
                          deleteData: record,
                          editType: "solo",
                        });
                      } else {
                        this.props.pushToast({
                          type: 'error',
                          message: 'You are not authorized to delete this service'
                        })
                      }
                    }}
                  >
                    <Delete />
                  </span>
                )}
              </div>
            ),
          }
        )
      }

      const appId = this.props.match.params.appId;
      const versionId = this.props.appVersion && this.props.appVersion.versionId;
      const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
      return (
        canViewService ?
          <div className='viewWrapper'>
            {
              ((!this.state.loading) && (currentBranchId !== null) && (this.state.soloServiceList && this.state.soloServiceList.length > 0))
                ?
                <div className={"row " + style.data}>
                  <div className={style.header} >
                  <div className={style.first}>
                      <h4>Services</h4>
                      <h5>View, edit or create a new service</h5>
                    </div>
                    <div className={"flex " + style.first}>
                      <SearchBar
                        ref={this.state.searchRef}
                        data={this.state.soloServiceList}
                        columns={soloColumns}
                        onFilter={(filteredData ) => {
                          this.setState({
                            filteredData: filteredData,
                          })
                        }}
                        onSearchTermChange={ (searchValue: string)=>{ this.setState({searchValue: searchValue}) } }
                      />
                      {
                        canCreateService &&
                        (
                          <Button dataTestId="create_service" size="small" onClick={() => { this.setState({ visible: true }); this.props.selectedServices(null) }}>
                            CREATE SERVICE
                          </Button>
                        )
                      }
                    </div>
                  </div>
                  <div className={style.content}>
                    <Table
                      pagination={false}
                      // rowSelection={{ 
                      //   type : 'checkbox',
                      //   onChange: (selectedRowKeys, selectedRows) => {
                      //   }
                      // }}
                      scroll={{ y: 'calc(100vh - 240px)' }}
                      columns={soloColumns}
                      onRow={(record: any, rowIndex: any) => {
                        return {
                          'data-test-id': 'service_table_row_' + record.key,
                          onClick: (event: any) => {
                            const tag: any = event.target;
                            if (tag.id !== "delete") {
                              this.props.selectedServices("solo")
                              this.props.history.push(
                                "" +
                                this.props.match.url +
                                "/" +
                                record.id +
                                "/create"
                              );
                            }
                          }
                        };
                      }}
                      className={"override-table-container"}
                      dataSource={this.state.filteredData!.map((res, key) => {
                        return { ...res, key: key };
                      })}
                    />
                  </div>
                </div>
                :
                (this.state.loading)
                  ?
                  <div className={style.loadingSpinner}>
                    <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                  </div>
                  :
                  <NoData
                    image={serviceImg}
                    header='Create Service'
                    content='Create services for your apps'
                    // buttonText='Create new version'
                    buttonCallback={() => (canCreateService) ? (this.setState({ visible: true }), this.props.selectedServices(null)) : this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to create services'
                    })}
                  />}
            <>
              {/* {!this.state.loading && this.state.serviceList && this.state.serviceList.length > 0
              ? */}
            </>

            <ServiceModal
              visible={this.state.visible}
              editType={this.state.editType}
              getSoloService={() => this.getSoloService(this.props)}
              appId={appId}
              versionId={versionId}
              setvisible={(status) => this.setState({ visible: status })}
            ></ServiceModal>
            {
              this.state.aclDrawerVisible ?
                <AclServiceDrawer versionId={versionId} isSolo={true}  getService={(() => { this.getSoloService(this.props) })} pushToast={this.props.pushToast} aclServiceData={this.state.editInitialData} onClose={(() => { this.setState({ aclDrawerVisible: false }) })}></AclServiceDrawer> : null
            }
            {this.state.editvisible && (
              <ServiceModal
                getSoloService={() => this.getSoloService(this.props)}
                visible={this.state.editable}
                editInitialData={this.state.editInitialData}
                editSoloIntitialData={this.state.editSoloIntitialData}
                editType={this.state.editType}
                appId={appId}
                versionId={versionId}
                setvisible={(status) => {
                  this.setState({ editable: status, editInitialData: {}, editSoloIntitialData: {} });
                  setTimeout(() => {
                    this.setState({ editvisible: false });
                  }, 400);
                }}
                editable={this.state.editable}
              ></ServiceModal>
            )}
            <Modal
              id="deleteSoloService"
              dataTestId="delete_Soloservice"
              unmountOnCancel={true}
              visible={this.state.deleteVisible}
              title="DELETE SOLO SERVICE"
              onCancel={() => {
                this.setState({
                  deleteVisible: false,
                  deleteData: {},
                });
              }}
              deleteOptions={{
                type: "Service",
                validateString: this.state.deleteData.name
              }}
              footer={{
                enable: true,
                okText: "DELETE",
                cancelText: "CANCEL",
                onOk: () => {
                  this.deleteSoloService(this.state.deleteData.id);
                },
              }}
            />
          </div>
          :
          <div className="viewWrapper">
            <NoData
              svg={WarningIcon}
              header='Not Authorized'
              content='Please request owner of this organization to provide access'
              noButton={true}
            />
          </div>
      );
    // }
  }
}

interface ServiceModelProps {
  visible: boolean;
  getSoloService: () => void;
  setvisible: (status: boolean) => void;
  appId: any;
  versionId: any;
  editSoloIntitialData?: {};
  editInitialData?: {};
  editable?: boolean;
  editType: string;
}
let onSubmit: any;
const ServiceModal = ({ visible, getSoloService, setvisible, editType, appId, versionId, editSoloIntitialData, editInitialData, editable }: ServiceModelProps) => {
  return (
    <Modal
      id="createEditService"
      dataTestId="create_edit_service"
      title={editInitialData ? "EDIT SERVICE" : "CREATE SERVICE"}
      visible={visible}
      onCancel={() => {
        setvisible(false);
      }}
      unmountOnCancel={true}
      footer={{
        enable: true,
        okText: editable ? "SAVE" : "CREATE",
        cancelText: "CANCEL",
        onOk: () => {
          onSubmit();
        },
      }}
    // mode='EditCreate'
    >
      <Service
        data-test-id="service"
        appId={appId}
        versionId={versionId}
        getSoloService={getSoloService}
        editInitialData={editInitialData}
        editSoloIntitialData={editSoloIntitialData}
        onSubmit={(submit) => (onSubmit = submit)}
        setvisible={(data) => setvisible(data)}
        editable={editable}
        editType={editType}
      ></Service>
    </Modal>
  );
};
const mapStateToProps = (state: AppState, props: Props) => {
  const params: any = props.match.params;
  return {
    appVersion: state.apps.appVersion[params['appId']],
    orgPermissions: state.org.orgPermissions,
    appPermissions: state.apps.selectedApp.permissions,
    currentBranch: state.apps.appBranch
  }
};

export default connect(mapStateToProps, { pushToast, selectedServices })(ServiceList);
